import { useEffect } from "react";
import { Input, Spinner } from "reactstrap";
import useToggle from "../../../../hook/useToggle";
import { Action } from "../../../../types/reducer-action";
import AccordionContainer from "../../../common/accordion-container";
import { DataEntryEvent } from "../../../common/data-entry-reducer";
import { AddIcon } from "../../../common/icons";
import useUserApi from "../useUserApi";
import { UserManagerDomain, useUserDispatch, useUserState } from "../user-manager-context";
import NewMemoModal from "./new-memo-modal";
import './style.scss';
import UserMemosTable from "./user-memos-table";
import AutoFocusDiv from "../../../common/auto-focus-div";
import Button from "../../../common/button";

export default function UserMemosTab() {
  const { selectedDataId } = useUserState();

  const { getUserMemos, busy } = useUserApi();

  useEffect(() => {
    !!selectedDataId && getUserMemos(selectedDataId);
  }, [selectedDataId]);

  if (busy) return <Spinner className="container my-5" aria-busy="true" />;

  return (
    <section className="oms-container">
      <MemoActionPane />

      <UserMemosTable />

      <MemoDetailsPane />
    </section>
  );
}

function MemoActionPane() {
  const dispatch = useUserDispatch();

  const { isOpen: isCreationModalOpen, toggle: toggleCreationModal } = useToggle();

  const handleNew = () => {
    dispatch(new Action(UserManagerDomain.Memos + DataEntryEvent.NewForm,));
    toggleCreationModal();
  };

  return (
    <div>
      <Button type="button" color="primary" className="action-link"
        onClick={handleNew}>
        <AddIcon /> Create New Memo
      </Button>

      <NewMemoModal isOpen={isCreationModalOpen} toggle={toggleCreationModal} />
    </div>
  );
}

function MemoDetailsPane() {
  const { subdomains } = useUserState();

  const { [UserManagerDomain.Memos]: memoState } = subdomains;
  const { dataDetails } = memoState ?? {};

  if (!dataDetails) return <></>;

  return (
    <AccordionContainer title="Memo">
      <AutoFocusDiv trigger={dataDetails}>
        <Input type="textarea" value={dataDetails?.memoTxt} rows={3} readOnly />
      </AutoFocusDiv>
    </AccordionContainer>
  );
}
